import type { RouteConfig } from 'vue-router';

export default [
  /**
   * 订单
   */
  {
    path: '/order',
    meta: {
      title: '我的订单',
      background: '#f6f7fb',
      excludeTracking: true,
    },
    component: () => import('@/views/order/index.vue'),
  },
  {
    path: '/order/rights',
    meta: {
      title: '优选订单',
      background: '#f6f7fb',
    },
    component: () => import('@/views/order/rights-order.vue'),
  },
  /**
   * 订单详情
   */
  {
    path: '/order/detail/:id',
    meta: {
      title: '订单详情',
      background: '#f6f7fb',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/order/detail.vue'),
  },
  /**
   * 退款成功
   */
  {
    path: '/order/success',
    meta: {
      title: '提交结果',
      background: '#f6f7fb',
    },
    component: () => import('@/views/order/success.vue'),
  },
  /**
   * 还款宝权益领取列表
   */
  {
    path: '/order/repayment-card-interests/:id',
    meta: {
      title: '详情',
      background: '#f6f7fb',
      customNavBar: true,
    },
    component: () => import('@/views/order/repayment-card-interests.vue'),
  },
  /**
   * vip卡退款冷静期页面
   */
  {
    path: '/order/vip-order-refund',
    meta: {
      title: '申请退款',
      background: '#f6f7fb',
    },
    component: () => import('@/views/order/vip-order-refund.vue'),
  },
  /**
   * 还款宝退款冷静期页面
   */
  {
    path: '/order/repayment-order-refund',
    meta: {
      title: '申请退款',
      background: '#f6f7fb',
    },
    component: () => import('@/views/order/repayment-order-refund.vue'),
  },
  /**
   * 会员月卡退款冷静期页面
   */
  {
    path: '/order/vip-month-order-refund',
    meta: {
      title: '申请退款',
      background: '#f6f7fb',
    },
    component: () => import('@/views/order/vip-month-order-refund.vue'),
  },
  /**
   * 臻选计划已使用权益页面
   */
  {
    path: '/order/vip-used-rights',
    meta: {
      title: '申请退款',
      background: '#F8F9FF',
      excludeTracking: true,
    },
    component: () => import('@/views/order/vip-used-rights.vue'),
  },
  /**
   * 臻选计划未使用权益页面
   */
  {
    path: '/order/vip-unused-rights',
    meta: {
      title: '申请退款',
      background: '#F8F9FF',
      excludeTracking: true,
    },
    component: () => import('@/views/order/vip-unused-rights.vue'),
  },
  /**
   * 臻选计划权益挽留页面
   */
  {
    path: '/order/vip-detainment',
    meta: {
      title: '待领取',
      background: '#F8F9FF',
    },
    component: () => import('@/views/order/vip-detainment.vue'),
  },
  /**
   * 订单详情
   */
  {
    path: '/order/rights/detail/:id',
    meta: {
      background: '#f6f7fb',
      customNavBar: true,
    },
    component: () => import('@/views/order/rights-detail.vue'),
  },
  // /**
  //  * 会员月卡取消续订冷静期页面
  //  */
  // {
  //   path: '/order/vip-month-order-cancel-renew',
  //   meta: {
  //     title: '取消续订',
  //     background: '#F8F9FF',
  //   },
  //   component: () => import('@/views/order/components/vip-month-order-cancel-renew.vue'),
  // },
  /**
   * 退款申请受理
   */
  // {
  //   path: '/order/refund-result',
  //   meta: {
  //     title: '退款申请受理中',
  //     background: '#f6f7fb',
  //     customNavBar: true,
  //   },
  //   component: () => import('@/views/order/vip-order/result.vue'),
  // },
] as RouteConfig[];
